import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import IconFolder from "@/components/icons/IconFolder.vue";
import IconFolderOpen from "@/components/icons/IconFolderOpen.vue";
import IconArrowDown from "@/components/icons/IconArrowDown.vue";

import { ICategoryRow } from "../interfaces";

@Component({
  name: "UpperCategory",
  components: {
    "icon-folder": IconFolder,
    "icon-folder-open": IconFolderOpen,
    "icon-arrow-down": IconArrowDown,
  },
})
class UpperCategory extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  readonly row!: ICategoryRow;

  @Prop({ type: String, default: "" })
  readonly col!: string;

  @Prop({ type: String, default: "" })
  readonly htmlContent!: string;

  render() {
    if (this.col === "name") {
      return (
        <td class={[`clickable`, `data-${this.col}`]}>
          <div class="tablerow__name">
            <icon-base
              width="17"
              height="16"
              viewBox="0 0 5.292 4.233"
              class="tablerow__icon"
              name="folder"
              color="#f7ba00"
            >
              {this.row.type === "category" ? (
                <icon-folder />
              ) : (
                <icon-folder-open />
              )}
            </icon-base>
            {this.row.type === "upperCategory" && (
              <icon-base
                width="10"
                height="10"
                viewBox="0 0 4.233 4.233"
                class="tablerow__arrdown"
                name=""
                color="#474747"
              >
                <icon-arrow-down />
              </icon-base>
            )}
            <div class="highlight" domPropsInnerHTML={this.htmlContent} />
          </div>
        </td>
      );
    }
    return <td class={[`clickable`, `data-${this.col}`]}></td>;
  }
}

export default UpperCategory;
